import { TFunction } from "i18next";
import * as Yup from "yup";

import { AssetExpensePosition } from "../../../api/ClientFileApi";
import { nullableAmount, nullableText } from "../../utils/validation.utils";
import { AssetExpensesFormValues, ExpensesMaxLength } from "./ExpensesView.types";

const TAB = "clients.client.debtSettlement.assetInventory.expensesTab";
const SECTION = `${TAB}.validation`;

export function createExpensesSchema(t: TFunction) {
  return Yup.lazy((values: AssetExpensesFormValues) => {
    const isShared = values.paysCostsAlone === false;

    const positionSchema = () =>
      Yup.object().shape({
        debtorShare: nullableAmount(t),
        amount: isShared
          ? nullableAmount(t).test("covers-share", t(`${SECTION}.amountBelowShare`), function (value) {
              const share = (this.parent as { debtorShare: number | null }).debtorShare;
              return value == null || share == null || value >= share;
            })
          : nullableAmount(t),
      });

    return Yup.object().shape({
      illnessExtraCostAmount: nullableAmount(t),
      costSharingExplanation: nullableText(t, ExpensesMaxLength.costSharingExplanation),
      expenseRemarks: nullableText(t, ExpensesMaxLength.expenseRemarks),
      positions:
        values.paysCostsAlone == null
          ? Yup.object()
          : Yup.object().shape(
              Object.fromEntries(Object.values(AssetExpensePosition).map((p) => [p, positionSchema()]))
            ),
    });
  });
}
